
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.48 2.52a7.749 7.749 0 00-10.96 0 7.749 7.749 0 000 10.96 7.749 7.749 0 0010.96 0 7.749 7.749 0 000-10.96zM9.25 12.125a.375.375 0 01-.376.376L7.126 12.5a.375.375 0 01-.376-.376l.013-2.886-2.888.011a.375.375 0 01-.376-.375l.003-1.748c0-.208.168-.376.375-.376l2.886.014-.01-2.889c0-.207.167-.375.375-.375h1.75c.208 0 .375.168.375.375l-.015 2.889 2.888-.011c.208 0 .376.167.376.375v1.75a.375.375 0 01-.376.376l-2.888-.016.011 2.889z"}})])
          )
        }
      }
    